// utils/convertWavToMp3.js
import lamejs from 'lamejs';
export const convertWavToMp3 = async (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = async () => {
            try {
                // LameJSを動的にロード
                // const lamejs = await import(
                //     'https://user-data.kurikurikuricloud.com/lame.js'
                // );
                const lamejs = window.lamejs;
                const { WavHeader, Mp3Encoder } = lamejs;

                const wavHeader = WavHeader.readHeader(new DataView(reader.result));
                if (!wavHeader) {
                    console.log("WAVヘッダーの読み込みに失敗しました。");
                }
                const samples = new Int16Array(
                    reader.result,
                    wavHeader.dataOffset,
                    wavHeader.dataLen / 2
                );

                const channels = wavHeader.channels;

                if (channels !== 1 && channels !== 2) {
                    console.log(`未対応のチャンネル数です: ${channels}`);
                }

                const mp3encoder = new Mp3Encoder(
                    channels,
                    wavHeader.sampleRate,
                    128
                );

                const mp3Data = [];
                const blockSize = 1152;

                if (channels === 1) {

                    // モノラル
                    for (let i = 0; i < samples.length; i += blockSize) {
                        const mono = samples.subarray(i, i + blockSize);

                        const mp3buf = mp3encoder.encodeBuffer(mono);

                        if (mp3buf.length > 0) {
                            mp3Data.push(new Int8Array(mp3buf));
                        }
                    }

                } else {

                    // ステレオ
                    const frameCount = samples.length / 2;

                    for (let i = 0; i < frameCount; i += blockSize) {

                        const left = new Int16Array(
                            Math.min(blockSize, frameCount - i)
                        );

                        const right = new Int16Array(
                            Math.min(blockSize, frameCount - i)
                        );

                        for (let j = 0; j < left.length; j++) {
                            left[j] = samples[(i + j) * 2];
                            right[j] = samples[(i + j) * 2 + 1];
                        }

                        const mp3buf = mp3encoder.encodeBuffer(left, right);

                        if (mp3buf.length > 0) {
                            mp3Data.push(new Int8Array(mp3buf));
                        }
                    }
                }

                const mp3buf = mp3encoder.flush();
                if (mp3buf.length > 0) {
                    mp3Data.push(new Int8Array(mp3buf));
                }

                const mp3FileName = file.name.replace(/\.[^/.]+$/, "") + ".mp3";
                const mp3Blob = new Blob(mp3Data, { type: 'audio/mp3' });
                const mp3File = new File([mp3Blob], mp3FileName, { type: 'audio/mp3' });

                resolve(mp3File);
            } catch (error) {
                reject(error);
            }
        };
        reader.onerror = () => reject(new Error("ファイル読み込み失敗"));
        reader.readAsArrayBuffer(file);
    });
};

// 自動変換関数
export const autoConvertFiles = async (files) => {
    const convertedFiles = [];

    for (const file of files) {
        if (file.type.startsWith('audio/wav')) {
            try {
                console.log("変換中:", file.name);
                const convertedFile = await convertWavToMp3(file);
                convertedFiles.push(convertedFile);
            } catch (error) {
                console.error("変換失敗:", file.name, error);
                // 変換失敗時は元のファイルをそのまま使用
                convertedFiles.push(file);
            }
        } else {
            // WAV以外はそのまま追加
            convertedFiles.push(file);
        }
    }

    return convertedFiles;
};
